/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для менеджеров
   */
  app.Managers = app.Collection.extend({
    
    model: app.Manager,
    
    queryParams: {},
    
    run: function () {
      this.queryParams.expand = 'spec,districts';
    },
    
    url: function () {
      var params = [];
      var paramsStr = '';
      for (var name in this.queryParams) {
        if (this.queryParams.hasOwnProperty(name)) {
          params.push(name + '=' + this.queryParams[name]);
        }
      }
      if (params.length) {
        paramsStr = '?' + params.join('&');
      }
      return app.entryScriptName + '/api/v3/manager/' + paramsStr;
    },
    
    setQueryParams: function (params) {
      this.queryParams = params;
      this.queryParams.expand = 'spec,districts';
    }
    
  });
  
})();

}.call(window));